import { useMutation } from 'react-query';
import * as sapi from '../services/sapi';

export default () => useMutation('restartIngestor', () => sapi.post('/dri/ingestor/restart', {}));
